module.exports = __webpack_public_path__ + "img/consultation3.1a8547ab.png";